import { useEffect, useRef } from "react";
import { Alert, Col, Row } from "reactstrap";

// Clave pública de ONVO (no es secreta; identifica la cuenta comercio en el widget).
// Misma clave usada en la administración de suscripción.
export const ONVO_PUBLIC_KEY =
  "onvo_test_publishable_key_5NAA2U_A9-ZkYVt8nFg0jwnMib5N11vEbAE3HMkDL72kcf7N7U1JAbsimt94xxdmhIO6lyuSh9i4lpW9nBBNEw";

type OnvoSubscriptionPaymentProps = {
  customerId: string;
  subscriptionId: string;
  onSuccess: (data: any) => void;
  onError?: (data: any) => void;
  /** Oculta el bloque de mensajería de seguridad si el contenedor ya lo muestra. */
  hideSecurityNotice?: boolean;
};

/**
 * Renderiza el formulario de pago de suscripción de ONVO Pay junto con la mensajería de
 * seguridad (Easypos no guarda datos de tarjetas; todo lo procesa ONVO Pay de forma cifrada).
 * Reutilizable por el wizard de registro y la administración de suscripción.
 */
const OnvoSubscriptionPayment = ({
  customerId,
  subscriptionId,
  onSuccess,
  onError,
  hideSecurityNotice,
}: OnvoSubscriptionPaymentProps) => {
  const targetRef = useRef<HTMLDivElement>(null);
  // Refs para que el callback de ONVO use siempre la última función sin re-renderizar el widget.
  const onSuccessRef = useRef(onSuccess);
  const onErrorRef = useRef(onError);
  useEffect(() => { onSuccessRef.current = onSuccess; }, [onSuccess]);
  useEffect(() => { onErrorRef.current = onError; }, [onError]);

  useEffect(() => {
    const target = targetRef.current;
    if (!window.onvo || !target || !customerId || !subscriptionId) return;
    // Limpia cualquier render previo para no montar más de un formulario.
    target.innerHTML = "";
    window.onvo.pay({
      onError: (data: any) => {
        console.error("[onvo] error", data);
        onErrorRef.current?.(data);
      },
      onSuccess: (data: any) => {
        onSuccessRef.current(data);
      },
      publicKey: ONVO_PUBLIC_KEY,
      subscriptionId: `${subscriptionId}`,
      paymentType: "subscription",
      customerId: `${customerId}`,
    }).render(target);
  }, [customerId, subscriptionId]);

  return (
    <div>
      {!hideSecurityNotice && (
        <Alert color="info">
          <p className="mb-1">
            ✅ La información de su tarjeta <b>no es almacenada por Easypos</b>: es procesada de forma
            segura y cifrada por nuestro socio certificado <b>ONVO Pay</b>.
          </p>
          <p className="mb-0">
            🔒 La conexión utiliza un certificado SSL activo, transmitiendo los datos directamente a
            ONVO Pay bajo los más altos estándares de protección.
          </p>
        </Alert>
      )}
      <Row>
        <Col xs="12" md={{ offset: 2, size: 8 }} lg={{ offset: 3, size: 6 }}>
          <div ref={targetRef}></div>
        </Col>
      </Row>
    </div>
  );
};

export default OnvoSubscriptionPayment;
